export enum RefundAnimal {
    Sheep = 1,
    Reindeer = 2
}
